var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"id":_vm.id,"label":_vm.etiket,"name":_vm.name},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }